<template>
  <div class="car-message-user-logo">
    {{ getInitials() }}
  </div>
</template>

<script>
export default {
  name: 'UserLogo',
  props: ['firstname', 'lastname'],
  methods: {
    getInitials: function() {
      if (this.firstname && this.lastname) {
        return (this.firstname[0] + this.lastname[0]).toUpperCase();
      }
      return '';
    }
  }
}
</script>
